module.exports = __webpack_public_path__ + "static/media/Github.fe82ec00.svg";